import { SystemProductSelectPtBr } from "./system-product-select-pt-br";

export const SYSTEM_PRODUCT_SELECT_ES_ES: SystemProductSelectPtBr = {
	label: "Producto de sistema",
	placeholder: "Seleccione un producto de sistema",
};
